export default __webpack_public_path__ + "static/pic-6-faf77267c01ea3a0eb67bdcb5e615ae7.png";